import {h, render} from 'preact';

function Results({items}) {
    return (<div>
            {Array.isArray(items) &&
                <nav className="mSearchResultGrid">
                    {items.map(({link, title, contentType, isViewed}) => (
                        <article className="mSearchResultCard">
                            <a href={link}>
                                <h1 className="mSearchResultCard__Title">{title}</h1>
                                <h2 className="mSearchResultCard__Type">{contentType}</h2>
                                <div className="mSearchResultCard__Viewed">
                                    {isViewed === true &&
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.2" height="14.2"
                                             viewBox="0 0 14.2 14.2">
                                            <g>
                                                <path className="sVu" fill="#323232"
                                                      d="M2.2,7.1L5,10.8l7-9.6L13,2L5,13l-3.9-5L2.2,7.1z"></path>
                                            </g>
                                        </svg>
                                    }
                                </div>
                            </a>
                        </article>))}
                </nav>}
        </div>
    )
}

export default Results
